import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative h-8" }
const _hoisted_2 = ["placeholder", "data-ui"]
const _hoisted_3 = ["data-ui"]

import { ref, watch } from 'vue';

// Define props

export default /*@__PURE__*/_defineComponent({
  __name: 'TRInput',
  props: {
  modelValue: String,
  placeholder: String,
  inputClass: String,
  class: String,
  dataUi: String,
  focusAfterClear: {
    type: Boolean,
    default: false,
  },
  onEnter: {
    type: Function,
    default: () => {},
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

// Define emits
const emit = __emit;

// Reactive state
const inputValue = ref(props.modelValue);
const inputRef = ref<HTMLInputElement | null>(null);

// Methods
const emitUpdate = () => {
  emit('update:modelValue', inputValue.value);
};

const clearInput = () => {
  inputValue.value = '';
  emit('update:modelValue', '');
  if (props.focusAfterClear && inputRef.value) {
    inputRef.value.focus();
  }
};

// Watch for changes in modelValue
watch(() => props.modelValue, (newValue) => {
  inputValue.value = newValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      type: "text",
      placeholder: __props.placeholder,
      class: _normalizeClass(["pl-2 pr-4 h-8 outline-0 focus:outline-none", props.class]),
      onInput: emitUpdate,
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (__props.onEnter && __props.onEnter(...args)), ["enter"])),
      "data-ui": __props.dataUi
    }, null, 42, _hoisted_2), [
      [_vModelText, inputValue.value]
    ]),
    (inputValue.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          "data-ui": __props.dataUi + '-clear',
          class: "absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
          onClick: clearInput
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fas fa-times" }, null, -1)
        ]), 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})